var map = {
	"./africa.js": [
		"wZvj",
		946
	],
	"./canada.js": [
		"Y0MN",
		922
	],
	"./eurasia.js": [
		"LPRh",
		68
	],
	"./europe.js": [
		"b8PS",
		590
	],
	"./usa.js": [
		"/MM1",
		345
	],
	"./world.js": [
		"F2xv",
		810
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "hUZf";
module.exports = webpackAsyncContext;